<template>
  <b-card no-body>
    <b-media
      class="mb-md-3 bg-form-header d-flex flex-sm-row flex-column-reverse justify-content-between align-items-center p-1 p-md-2 rounded"
      no-body
    >
      <div class="d-flex justify-content-start align-items-center mt-sm-0 mt-2">
        <b-media-aside class="mr-1">
          <b-avatar size="45" class="rounded-avatar bg-secondary" />
        </b-media-aside>
        <b-media-body class="d-flex align-items-center text-white">
          <h4 class="font-weight-bolder text-white mb-0">Fees and awards</h4>
          <feather-icon
            icon="HelpCircleIcon"
            size="16"
            class="font-weight-bolder ml-1 rounded-circle cursor-pointer"
            v-b-tooltip.hover="'Fees and awards'"
          />
        </b-media-body>
      </div>
      <b-link :to="{ name: 'competitions' }">
        <span>back to the competitio list </span>
        <feather-icon icon="ChevronRightIcon"
      /></b-link>
    </b-media>
    <b-card-body class="d-flex flex-wrap px-2">
      <b-col md="6" cols="12">
        <b-form-group label="Registration fee :" label-for="registration-fee">
          <validation-provider
            #default="{ errors }"
            name="Registration fee"
            vid="registration-fee"
            class="w-100"
            rules="required"
          >
            <div class="d-flex justify-content-start align-items-center">
              <b-form-input id="registration-fee" v-model="fee" />
              <feather-icon
                icon="HelpCircleIcon"
                size="22"
                class="font-weight-bolder ml-2 rounded-circle cursor-pointer"
                v-b-tooltip.hover="
                  'Participants will have to pay this money to be able take part in the competition'
                "
              />
            </div>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>

      <b-col md="6" cols="12">
        <b-form-group label="Award type :" label-for="award-type">
          <validation-provider
            #default="{ errors }"
            name="Award type"
            vid="award-type"
            class="w-100"
            rules="required"
          >
            <div class="d-flex justify-content-start align-items-center">
              <select-box
                id="award-type"
                v-model="award_type"
                class="w-100"
                searchable
                select="value"
                label="name"
                :lists="[
                  { name: 'absolute', value: 'ABSOLUTE' },
                  { name: 'percentage', value: 'PERCENTAGE' },
                ]"
              />
              <feather-icon
                icon="HelpCircleIcon"
                size="22"
                class="font-weight-bolder ml-2 rounded-circle cursor-pointer"
                v-b-tooltip.hover="
                  'Specify how you want to award the winners using the options available in the menu'
                "
              />
            </div>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
      <!-- <b-col md="6" cols="12">
        <b-form-group
          label="Award distribution (%) :"
          label-for="Award distribution"
        >
          <validation-provider
            #default="{ errors }"
            name="Award distribution"
            vid="award-distribution"
            class="w-100"
            rules="required"
          >
            <div class="d-flex justify-content-start align-items-center">
              <b-form-input
                id="award-distribution"
                type="number"
                min="0"
                max="100"
                v-model="award_percent"
              />
              <feather-icon
                icon="HelpCircleIcon"
                size="22"
                class="font-weight-bolder ml-2 rounded-circle cursor-pointer"
                v-b-tooltip.hover="' '"
              />
            </div>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col> -->
      <b-col md="6" cols="12">
        <b-form-group
          :label="`Total awards (${award_type === 'ABSOLUTE' ? '$' : '%'}) :`"
          label-for="total-awards"
        >
          <validation-provider
            #default="{ errors }"
            name="Total awards"
            vid="total-awards"
            class="w-100"
            :rules="`required${
              award_type === 'percentage'
                ? '|max-value:100'
                : userData.plan && userData.plan.min_award
                ? '|max-value:' + Number(userData.plan.min_award).toFixed(2)
                : ''
            }`"
          >
            <div class="d-flex justify-content-start align-items-center">
              <b-form-input
                id="total-awards"
                v-model="award"
                type="number"
                step="0.0001"
                v-if="award_type === 'ABSOLUTE'"
                :max="
                  userData.plan && userData.plan.min_award
                    ? Number(userData.plan.min_award).toFixed(2)
                    : ''
                "
              />
              <b-form-input
                v-else
                id="total-awards"
                v-model="award"
                type="number"
                min="1"
                max="100"
              />
              <feather-icon
                icon="HelpCircleIcon"
                size="22"
                class="font-weight-bolder ml-2 rounded-circle cursor-pointer"
                v-b-tooltip.hover="
                  'This is the sum of money allocated to all winners'
                "
              />
            </div>

            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>

      <b-col cols="12">
        <b-button @click="addWinner" variant="primary">Add winner</b-button>
        <feather-icon
          icon="HelpCircleIcon"
          size="22"
          class="font-weight-bolder ml-2 rounded-circle cursor-pointer"
          v-b-tooltip.hover="
            'This is the sum of money allocated to all winners'
          "
        />
      </b-col>
      <b-col cols="12" class="mt-1">
        <span class="text-danger" v-if="isTotal">{{ isTotal }}</span>
        <hr />
      </b-col>
      <div
        class="w-100 d-flex flex-wrap"
        v-for="(award, index) in awards"
        :key="index"
      >
        <b-col md="6" cols="12">
          <b-form-group
            label="Winner award rank :"
            label-for="winner-award-rank"
          >
            <validation-provider
              #default="{ errors }"
              name="Winner award rank"
              :vid="`winner-award-rank-${index}`"
              class="w-100"
              rules="required"
            >
              <div class="d-flex justify-content-start align-items-center">
                <b-form-input
                  :id="`winner-award-rank-${index}`"
                  type="number"
                  min="1"
                  v-model="award.rank"
                />
              </div>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col md="6" cols="12">
          <b-form-group
            label="Winner award percent :"
            label-for="winner-award-percent"
          >
            <validation-provider
              #default="{ errors }"
              name="Winner award percent"
              :vid="`winner-award-percent-${index}`"
              class="w-100"
              rules="required"
            >
              <div class="d-flex justify-content-start align-items-center">
                <b-form-input
                  :id="`winner-award-percent-${index}`"
                  type="number"
                  min="1"
                  max="100"
                  class="mr-50"
                  v-model="award.percent"
                />
                <b-button
                  variant="outline-danger"
                  size="sm"
                  v-if="awards.length > 1"
                  v-b-tooltip.hover="'Delete winner'"
                  @click="removeWinner(index)"
                >
                  <feather-icon icon="XCircleIcon"
                /></b-button>
              </div>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
      </div>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardText,
  BCardTitle,
  BCardHeader,
  BBadge,
  BButton,
  BMedia,
  BAvatar,
  BMediaAside,
  BMediaBody,
  BCardBody,
  BImg,
  BForm,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupAppend,
  BFormTextarea,
  VBTooltip,
  BLink,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import SelectBox from "@core/components/select-box/SelectBox.vue";
export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardText,
    BCardTitle,
    BCardHeader,
    BBadge,
    BButton,
    BMedia,
    BAvatar,
    BMediaAside,
    BMediaBody,
    BCardBody,
    BImg,
    BForm,
    BFormCheckbox,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    BFormTextarea,
    ValidationProvider,
    ValidationObserver,
    SelectBox,
    BLink,
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  data() {
    return {
      fee: "",
      award: "",
      award_type: "ABSOLUTE",
      winner_count: 1,
      awards: [
        {
          rank: "",
          percent: 0,
        },
      ],
      required,
    };
  },
  props: {
    competition: {
      type: Object,
      default: () => {},
    },
  },
  watch: {
    competition(val) {
      Object.keys(val).map((item) => {
        this[item] = val[item];
      });
    },
    isTotal(val) {
      this.$emit("handleWinners", val);
    },
    awards: {
      handler(val) {
        this.feesAndAwards.awards = val;
      },
      deep: true,
    },
    feesAndAwards: {
      handler(val) {
        this.$emit("feesAndAwards", val);
      },
      deep: true,
    },
  },
  computed: {
    userData() {
      return (
        this.$store.state.auth.userData ||
        JSON.parse(localStorage.getItem("userData"))
      );
    },
    feesAndAwards() {
      let newData = {
        fee: this.fee,
        award: this.award,
        award_type: this.award_type,
        awards: this.awards,
        winner_count: this.winner_count,
      };
      return newData;
    },
    isTotal() {
      let number = 0;
      let filters = [];
      this.awards.map((award, index) => {
        filters.push(
          ...this.awards.filter((filterAward, filterIndex) => {
            return filterIndex != index && filterAward.rank == award.rank;
          })
        );
      });
      if (filters.length) {
        return "The rank of the winners should not be the same";
      }
      this.awards.map((item) => {
        number += Number(item.percent);
      });
      if (number != 100) {
        return "The Sum of winners percent must be 100";
      }
      return false;
    },
  },
  methods: {
    addWinner() {
      this.winner_count++;
      this.awards.push({
        rank: "",
        percent: 0,
      });
    },
    removeWinner(i) {
      this.winner_count--;
      this.awards.splice(i, 1);
    },
  },
};
</script>

<style scoped>
.card {
  margin-bottom: 0 !important;
}
</style>
